import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { REQUEST_TYPES, useMyRequests, type RequestType } from '@/hooks/useMyRequests';
import { ApprovalDetailDrawer } from '@/components/approvals/ApprovalDetailDrawer';

const TYPE_ICON: Record<RequestType, string> = REQUEST_TYPES.reduce<Record<RequestType, string>>(
  (acc, t) => {
    acc[t.key] = t.icon;
    return acc;
  },
  {} as Record<RequestType, string>,
);

export function RecentRequestsList() {
  const { t } = useTranslation();
  const { data: items = [], isLoading } = useMyRequests();
  const [detailId, setDetailId] = useState<string | null>(null);

  return (
    <section className="req-list-card">
      <header className="req-list-header">
        <h3>{t('requests.recent')}</h3>
      </header>
      {isLoading ? (
        <div className="req-empty" aria-busy="true" />
      ) : items.length === 0 ? (
        <div className="req-empty">{t('requests.empty')}</div>
      ) : (
        items.map((r) => (
          <div
            key={r.id}
            className="req-row"
            role="button"
            tabIndex={0}
            onClick={() => setDetailId(r.id)}
          >
            <div className="req-row-icon">
              <span className="material-symbols-outlined">{TYPE_ICON[r.type]}</span>
            </div>
            <div className="req-row-info">
              <div className="req-row-title">{r.title}</div>
              <div className="req-row-time">{r.submittedAt}</div>
            </div>
            <span className="req-status" data-state={r.state}>
              {t(`requests.state_${r.state}`)}
            </span>
          </div>
        ))
      )}

      {/* Same drawer used by /approvals — my submissions ARE approval tasks */}
      <ApprovalDetailDrawer
        taskId={detailId}
        onClose={() => setDetailId(null)}
        allowActions={false}
      />
    </section>
  );
}
